import React, { useEffect } from 'react';
import { Controller, Control, useFormContext } from 'react-hook-form';
import {
	FormControl,
	InputLabel,
	Select,
	MenuItem,
	Box,
	Typography,
} from '@mui/material';
import {
	RegulationFormValues,
	ResponsibilityType,
	User,
} from '../../DataTable/dataTypes';

interface DropdownListFieldProps {
	control: Control<RegulationFormValues>;
	taskIndex: number;
	users: User[];
	// types: ResponsibilityType[];
	disabled?: boolean;
	responsibilityIndex: number;
	responsability: string,
	showLbl?: boolean;
	responsibility?: ResponsibilityType;
}

const DropdownListField: React.FC<DropdownListFieldProps> = ({
	control,
	taskIndex,
	users,
	//   types,
	disabled,
	responsibilityIndex,
	responsability,
	showLbl = true,
	responsibility
}) => {
	const { getValues, setValue } = useFormContext<RegulationFormValues>();
	const userPath = `tasks.${taskIndex}.taskUserResponsibilities.${responsibilityIndex}.user` as const;
	const responsibilityPath = `tasks.${taskIndex}.taskUserResponsibilities.${responsibilityIndex}.responsibility` as const;

	useEffect(() => {
		if (responsibility && getValues(userPath)) {
			setValue(responsibilityPath, responsibility, {
				shouldDirty: true,
				shouldValidate: true,
			});
		}
	}, [getValues, responsibility, responsibilityPath, setValue, userPath]);

	return <Box key={responsibilityIndex}>
		<Box mt={2} mb={2}>
			{showLbl &&
				<Typography variant="body2" color="textPrimary">
					{responsability}
				</Typography>
			}
		</Box>

		<FormControl variant="outlined" fullWidth>
			<InputLabel id={`user-label-${taskIndex}-${responsibilityIndex}`}>
				Responsable
			</InputLabel>
			<Controller
				name={userPath}
				control={control}
				render={({ field, fieldState }) => (
					<Select						
						{...field}
						labelId={`user-label-${taskIndex}-${responsibilityIndex}`}
						label="Responsable"
						value={field.value?.id || ''}
						onChange={(event) => {
							const selectedUser = users.find(
								(user) => user.id === event.target.value
							);
							field.onChange(selectedUser);
							if (responsibility) {
								setValue(
									responsibilityPath,
									responsibility,
									{ shouldDirty: true, shouldValidate: true }
								);
							}
						}}
						disabled={disabled}
						error={!!fieldState.error}
					>
						{users
							.sort((a, b) => a.username.localeCompare(b.username))
							.map((user) => (
								<MenuItem key={user.id} value={user.id}>
									{user.username}
								</MenuItem>
							))}
					</Select>
				)}
				rules={{
					required:
						'Debe seleccionar un usuario para esta responsabilidad',
				}}
			/>
		</FormControl>
	</Box>

}

export default DropdownListField;


